export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f3ea1d132fc6ea94141237f6c5074e1a6ebae9218&name=fetchTypeahead!'